import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { TabsContent } from '@/components/ui/tabs';
import { NATIONALITIES } from '@/constants/nationalities';

export default function IdentityTab({ formData, setFormData, formErrors, t, direction }) {
  return (
    <TabsContent value="identity" className="space-y-3 mt-3 h-[480px] overflow-y-auto pe-1">
      <div className="bg-white rounded-lg border border-[#C4BFF0] p-3 space-y-2">
        <p className="text-xs font-semibold text-[#655dc6]/70 tracking-wide">{t('identity_info')}</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs text-start block">{t('iqama_number')}</Label>
            <Input className={formErrors.iqama_number ? 'border-red-500' : ''} value={formData.iqama_number} onChange={(e) => setFormData(prev => ({ ...prev, iqama_number: e.target.value }))} data-testid="input-iqama" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-start block">{t('id_expiry_date')}</Label>
            <Input type="date" value={formData.id_expiry_date} onChange={(e) => setFormData(prev => ({ ...prev, id_expiry_date: e.target.value }))} data-testid="input-id-expiry" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs text-start block">{t('employee_number')}</Label>
            <Input className={formErrors.employee_number ? 'border-red-500' : ''} value={formData.employee_number} onChange={(e) => setFormData(prev => ({ ...prev, employee_number: e.target.value }))} data-testid="input-emp-number" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-start block">{t('nationality')}</Label>
            <Select value={formData.nationality} onValueChange={(v) => setFormData(prev => ({ ...prev, nationality: v }))} dir={direction}>
              <SelectTrigger className={formErrors.nationality ? 'border-red-500' : ''} data-testid="input-nationality"><SelectValue placeholder={t('nationality')} /></SelectTrigger>
              <SelectContent className="max-h-[200px]">
                {NATIONALITIES.map(n => (<SelectItem key={n} value={n}>{n}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </TabsContent>
  );
}
